import type { SignedUrlResponse } from "@/services/storageService.types";

import type { APIInstance } from "./apiService";

export class StorageService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  /**
   * `type` is passed to the API; supported values include `file`, `export`, and `ocr`.
   * No `customization_options` is sent for `export` — the backend resolves the latest
   * generated export for the version_id regardless of the caller's saved preferences.
   */
  async getSignedUrl(fileId: string, type: string = "file"): Promise<SignedUrlResponse> {
    const response = await this.api.get<SignedUrlResponse>(`/storage/${fileId}`, {
      params: { type },
    });
    return response.data;
  }
}
